/**
 * indexLoader.js. DO NOT apply var to these values. The vars file has not loaded yet.
 * Created by calhosh on 9/22/2020.
 */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const Loaderdiv = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 1 0%;
	height: 100%;
	position: relative;

	.main-wrapper,
	.right-container-loader,
	.header-loader,
	.high-level-filter-loader,
	.tile-loader,
	.filter-search-loader,
	.table-loader {
		margin: 0.5rem 1rem;
	}

	.main-wrapper {
		display: flex;
		position: relative;
		max-width: 2048px;
		padding: 0;
		flex: 1 1 0;
		overflow: hidden;
		height: 100%;
	}

	.right-container-loader {
		width: 100%;
		display: flex;
		padding-left: 30x;
		flex-direction: column;
		background: var(--neutrals-00white);
		height: 100%;
	}

	.high-level-filter,
	.tile-item,
	.filter-search-item {
		display: inline;
		margin: 0 0.2rem;
	}
`;

const IndexLoader = () => {
	return (
		<Loaderdiv>
			<section className="mainResponsiveWrapper">
				<section className="main-wrapper">
					<section className="right-container-loader">
						<section className="header-loader">
							<Skeleton width={'100%'} height={40} />
						</section>
						<section className="high-level-filter-loader">
							<section className="high-level-filter">
								<Skeleton width={'24.7%'} height={50} />
							</section>
							<section className="high-level-filter">
								<Skeleton width={'24.7%'} height={50} />
							</section>
							<section className="high-level-filter">
								<Skeleton width={'24.5%'} height={50} />
							</section>
							<section className="high-level-filter">
								<Skeleton width={'24.5%'} height={50} />
							</section>
						</section>
						<section className="tile-loader">
							<section className="tile-item">
								<Skeleton width={'49.6%'} height={200} />
							</section>
							<section className="tile-item">
								<Skeleton width={'49.5%'} height={200} />
							</section>
						</section>
						<section className="filter-search-loader">
							<section className="filter-search-item">
								<Skeleton width={'20%'} height={50} />
							</section>
							<section className="filter-search-item">
								<Skeleton width={'5%'} height={50} />
							</section>
							<section className="filter-search-item">
								<Skeleton width={'20%'} height={50} />
							</section>
						</section>
						<section className="table-loader">
							<Skeleton width={'100%'} height={400} />
						</section>
					</section>
				</section>
			</section>
		</Loaderdiv>
	);
};

export default IndexLoader;
